'use strict';

export default angular
  .module('maestro.filters.translateOrDefault', [])

  .filter('translateOrDefault', function($filter) {
    const $t = $filter('translate');
    return function(translationKey, defaultValue = '') {
      if (!translationKey) {
        return '';
      }
      let result = $t(translationKey);
      return result === translationKey ? defaultValue : result;
    };
  })

  .name;
